export const NOVA_POSHTA = 'NOVA_POSHTA';
export const UKR_POSHTA = 'UKR_POSHTA';
